import React from "react";
import BaseComponent from "../../redare/components/BaseComponent";
import Grid from "../../redare/components/grid/Grid";

import {TaskOrigin} from "../../common/ConstField";
import TaskReceiverPresenter from "../../.gen/presenter/TaskReceiverPresenter";
import {dateFormat} from "../../redare/utils/DateUtils";

export default class TaskReceiverGrid extends BaseComponent {

    intervalID = undefined;

    constructor(props) {
        super(props);
        this.searchParams = {};
        this.presenter = new TaskReceiverPresenter(this);
    }

    componentDidMount() {
        if (this.props.showPage) {
            this._findTaskReceiverPage()
        }else {
            this._findTaskList();
            this._registryInterval()
        }
    }

    componentWillUnmount() {
        if (this.intervalID) {
            window.clearInterval(this.intervalID)
        }
    }

    _registryInterval() {
        let {showPage} = this.props;
        if (showPage) {
            if (this.intervalID) {
                window.clearInterval(this.intervalID)
            }
            return
        }
        this.intervalID = window.setInterval(() => {
            this._findTaskList()
        }, 10000)
    }

    _findTaskList() {
        this.setGridLoading(true);
        this.presenter.findTaskReceiverPage(
            {},
            {},
            (result) => {
                let {data} = result;
                if (this.grid) {
                    this.grid.setData(data.result)
                }
            },
            () => {
                this.setGridLoading(false)
            }
        )
    }

    _findTaskReceiverPage(params = {}) {
        this.setGridLoading(true);
        this.searchParams = {...params};
        this.presenter.findTaskReceiverPage(
            this.searchParams,
            {curPage: this.curPage ?? 1},
            (result) => {
                let {data} = result;
                if (data && this.grid) {
                    let {result, curPage, pageSize, totalCount} = data;
                    this.grid.setData(result, {curPage, pageSize, totalCount})
                }
            },
            () => {
                this.setGridLoading(false)
            }
        )
    }

    //打开待办任务页面
    _openUpcoming(record) {
        let {url} = record;
        let ssoToken = window._workbench._ssoToken;
        let token = "";
        if (ssoToken) {
            token = ssoToken.token;
        }
        let rUrl = '';
        if (url) {
            if (url.indexOf("?") >= 0) {
                rUrl = `${url}&token=${token}`;
            } else {
                rUrl = `${url}?token=${token}`;
            }
        }
        if (rUrl !== '') {
            window.open(rUrl, "_blank");
        }
    }

    _onPageChange(curPage) {
        this.curPage = curPage;
        this._findTaskReceiverPage(this.searchParams)
    }

    render() {
        return (
            <Grid
                ref={(o) => {
                    this.grid = o
                }}
                _onPageChange={(page) => this._onPageChange(page.curPage)}
                _showPage={this.props.showPage}
                _initLoading={false}
                className={"task-receive-table"}
                scroll={{x: 'max-content'}}
                bordered={false}
                rowKey={(v) => v.id}
                columns={[
                    {
                        title: '任务名称',
                        dataIndex: 'title',
                        render: (value, record) => {
                            return <a onClick={() => this._openUpcoming(record)}>{value}</a>
                        }
                    },
                    {
                        title: '任务来源',
                        dataIndex: 'sysCode',
                        render: (value) => TaskOrigin[value]
                    },
                    {
                        title: '当前处理人',
                        dataIndex: 'userName',
                    },
                    {
                        title: '发起时间',
                        dataIndex: 'startTime',
                        render: (value) => dateFormat(value)
                    },
                ]}
            />
        )
    }

    setGridLoading(bool) {
        if (this.grid) {
            bool ? this.grid.showLoadingIndicator() : this.grid.closeLoadingIndicator()
        }
    }

}
